import React from 'react'
import { Icon } from "@material-ui/core";
import ChaosLogo from './litmus-icon-black.svg'

export const ChaosIcon = () => (
    React.createElement(Icon, null
        , React.createElement('img', { src: ChaosLogo, alt: "", height: 25, width: 25,})
    )
)